import useAuth from '@/hooks/useAuth';
import { useUpdateUserMutation } from '@/queries/user.queries';
import timezoneService from '@/services/timezone.service';
import { useTranslation } from 'react-i18next';

interface IUseTimeZoneModalProps {
	close: () => void;
}

export default function useTimeZoneModal(props: IUseTimeZoneModalProps) {
	const { t } = useTranslation();
	const { getCurrentUser } = useAuth();
	const updateUserMutation = useUpdateUserMutation();

	return {
		t,
		currentTimeZone: timezoneService.getTimeZone(),
		profileTimeZone: getCurrentUser().timeZone,
		handleChangeTimeZoneClick: () => {
			const timeZone = timezoneService.getTimeZone();
			updateUserMutation.mutateAsync({ timeZone }).then(() => {
				props.close();
			});
		},
	};
}
